import axios from 'src/api/Api';
import {
    GET_FIELD_INVENTORY_DASHBOARD_SUCCESS,
    GET_FIELD_INVENTORY_DASHBOARD_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
// Saga: GET /dashboard/dashboardDetails?currentTab=surgeryNeeds
export default function* getFieldInventoryDashboard(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const { districtCode, surgeryStartDate, surgeryEndDate, searchTerm, searchType, statusFilter,allocatedFilter ,surgeryTypeFilter} = action?.payload || {};
    const params = new URLSearchParams({
        search: 'false',
        refine: 'false',
        currentTab: 'surgeryNeeds',
        clearOnDefaultRefine: 'false',
        defaultPref: 'false',
        ...(districtCode     && { districtCode }),
        ...(surgeryStartDate && { surgeryStartDate }),
        ...(surgeryEndDate   && { surgeryEndDate }),
        ...(searchTerm       && { searchTerm }),
        ...(searchType      && { searchType }),
        ...(statusFilter    && { statusFilter }),
        ...(allocatedFilter   && { allocatedFilter }),
        ...(surgeryTypeFilter   && { surgeryTypeFilter }),
    });
    const url = `/occ/v2/${baseSiteId}/dashboard/dashboardDetails?${params.toString()}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({ type: GET_FIELD_INVENTORY_DASHBOARD_SUCCESS, payload: result });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });
        yield put({ type: GET_FIELD_INVENTORY_DASHBOARD_FAILURE, payload: { error: errorHandler('503') } });
    }
}
 
 